import styled from 'styled-components'

export const Container = styled.div`
width: 100%;
background-color: ${props => props.theme.colors.background};
`;